import { PaginationItem, PaginationRenderItemParams } from '@mui/material';
import Link from 'next/link';
import { FC } from 'react';
import { shouldDisplayPage } from './utils';

interface RenderPageItemProps {
    countTensRef: React.MutableRefObject<number>;
    currentPage: number;
    ellipsisShownRef: React.MutableRefObject<boolean>;
    item: PaginationRenderItemParams;
    totalPages: number;
    year: string;
}

const PaginationItemPublicDecisions: FC<RenderPageItemProps> = ({
    countTensRef,
    currentPage,
    ellipsisShownRef,
    item,
    totalPages,
    year,
}) => {
    if (item.page && shouldDisplayPage(item.page, currentPage, totalPages)) {
        ellipsisShownRef.current = false;
        countTensRef.current = item.page % 10 === 0 ? countTensRef.current + 1 : 0;

        return (
            <Link
                href={`/${
                    item.page === 1
                        ? `sitemap/decisions/${year}`
                        : `sitemap/decisions/${year}?page=${item.page}`
                }`}
            >
                <PaginationItem {...item} />
            </Link>
        );
    }

    if (!ellipsisShownRef.current && countTensRef.current === 0) {
        ellipsisShownRef.current = true;

        return <PaginationItem type="start-ellipsis" />;
    }

    return null;
};

export default PaginationItemPublicDecisions;
